
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { content } from './child-routes.module';
import { NotfoundComponent } from './authentication/404/not-found.component';

export const Approutes: Routes = [
	{
		path: '',
		redirectTo: 'consulta-facturador',
		pathMatch: 'full'
	},
	{
		path: '',
		component: BlankComponent,
		children: [
			{
				path: 'auth',
				loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
			},
			{
				path: 'consulta-facturador',
				loadChildren: () => import('./consulta-facturador/consulta-facturador.module').then(m => m.ConsultaFacturadorModule)
			}
		]
	},
	{
		path: '',
		component: FullComponent,
		// canActivate: [AuthGuard],
		children: content
	},
	{ path: '**', redirectTo: '/404', pathMatch: 'full' },
	{ path: '404', component: NotfoundComponent },
];
